export default __webpack_public_path__ + "static/media/AS.b36fa2e7.svg";